import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Notification from '../../components/Notification/Notification';
import AuthLayout from "../AuthLayout/AuthLayout";
import { Helmet } from "react-helmet";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  
  const [notification, setNotification] = useState({
    show: false,
    message: '',
    type: '' // 'success', 'error', 'info'
  });

  // ✅ Redirect agar user pehle se login hai
  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [navigate]);

  const showNotification = (message, type = 'error') => {
    setNotification({
      show: true,
      message,
      type
    });
    
    setTimeout(() => {
      setNotification(prev => ({ ...prev, show: false }));
    }, 5000);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      const res = await fetch("https://gladious-constructions.onrender.com/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem("adminToken", data.token);
        localStorage.setItem("adminName", data.name);
        showNotification('Login successful!', 'success');
        setTimeout(() => navigate("/admin/dashboard"), 1500);
      } else {
        showNotification(data.message || "Username or password incorrect");
      }
    } catch (err) {
      showNotification("Login failed. Please try again.");
      console.error("Login error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Notification 
        show={notification.show} 
        message={notification.message} 
        type={notification.type}
        onClose={() => setNotification(prev => ({ ...prev, show: false }))}
      />
      <Helmet>
        <title>Login | Admin</title>
        <meta 
          name="description" 
          content="Welcome to Gladious – experts in sustainable and modern construction projects." 
        />
      </Helmet>
      
      <AuthLayout
        title="Admin Login"
        onSubmit={handleLogin}
        rightTitle="Welcome, Admin!"
        submitButtonText={isLoading ? "Logging in..." : "Login"}
        isSubmitDisabled={isLoading}
      >
        <input
          type="email"
          placeholder="Admin Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={isLoading}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={isLoading}
        />
      </AuthLayout>
    </>
  );
};

export default AdminLogin;
